/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/compass-off': {
    width: 69,
    height: 69,
    viewBox: '0 0 69 69',
    data: '<circle cx="35.7394" cy="33.0178" r="28.0022" fill="white"/><path d="M34.1274 0C15.3096 0 0 15.3098 0 34.1279C0 52.9456 15.3096 68.2554 34.1274 68.2554C52.9455 68.2554 68.2554 52.9456 68.2554 34.1279C68.2554 15.3098 52.9455 0 34.1274 0ZM34.1277 43.3796L18.0782 53.4572L34.1277 8.89192L50.1772 53.4572L34.1277 43.3796Z" fill="black"/>'
  }
})
